import React from 'react'

// components
import CartProduct from './CartProduct'

// helpers
import {
  cartProductTotal,
  productDescription
} from 'lib/cart/decorators/cartProduct'
import { centsToDollars } from 'lib/helpers/money'

const RetailProduct = props => {
  const {
    cartProduct, // via props
    account // via props
  } = props

  return (
    <CartProduct
      key={cartProduct.id}
      description={productDescription(cartProduct)}
      total={centsToDollars(cartProductTotal(cartProduct, account))}
    />
  )
}

export default RetailProduct
